// Private parking listings — API wrappers. Same anonymous device identity as the
// rest of SpotDrop (X-Device-Id is injected by lib/api.js).

import { api, API } from "./api";

export const PERIOD_LABEL = { hourly: "/hour", daily: "/day", monthly: "/month" };

export function listingPhotoUrl(id) {
  return `${API}/private-parking/${id}/photo`;
}

export async function fetchListings(pos) {
  const params = pos ? { lat: pos.lat, lng: pos.lng } : {};
  const res = await api.get("/private-parking", { params });
  return res.data.listings || [];
}

export async function fetchMyListings() {
  const res = await api.get("/private-parking/mine");
  return res.data;
}

export async function fetchListingContact(id) {
  const res = await api.get(`/private-parking/${id}/contact`);
  return res.data;
}

export async function createListing({ title, price, period, description, lat, lng, whatsapp, email, photo }) {
  const fd = new FormData();
  fd.append("title", title);
  fd.append("price", String(price));
  fd.append("period", period);
  fd.append("description", description || "");
  fd.append("lat", String(lat));
  fd.append("lng", String(lng));
  if (whatsapp) fd.append("whatsapp", whatsapp);
  if (email) fd.append("email", email);
  fd.append("photo", photo);
  const res = await api.post("/private-parking", fd);
  return res.data;
}

export async function updateListing(id, payload) {
  const res = await api.put(`/private-parking/${id}`, payload);
  return res.data;
}

export async function deleteListing(id) {
  await api.delete(`/private-parking/${id}`);
}

/** Downscale a photo in the browser so uploads stay small (max 1280px, JPEG). */
export function resizePhoto(file, maxSide = 1280) {
  return new Promise((resolve) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      const scale = Math.min(1, maxSide / Math.max(img.width, img.height));
      if (scale === 1 && file.size < 1_500_000) {
        URL.revokeObjectURL(url);
        resolve(file);
        return;
      }
      const canvas = document.createElement("canvas");
      canvas.width = Math.round(img.width * scale);
      canvas.height = Math.round(img.height * scale);
      canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
      canvas.toBlob(
        (blob) => {
          URL.revokeObjectURL(url);
          resolve(blob ? new File([blob], "listing.jpg", { type: "image/jpeg" }) : file);
        },
        "image/jpeg",
        0.82
      );
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      resolve(file);
    };
    img.src = url;
  });
}
